import React from "react";
import Image from "react-bootstrap/Image";
import StudentController from "../api/StudentController";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface PersonViewProps
{
    data: Person;
    admins?: boolean;
}

interface PersonViewState
{
    imageDataUrl: string | null;
}

export default class PersonView extends React.Component<PersonViewProps, PersonViewState>
{
    studentController: StudentController;

    constructor(props: PersonViewProps)
    {
        super(props);
        this.studentController = new StudentController();
        this.state = {
            imageDataUrl: null
        };
    }

    async componentDidMount(): Promise<void>
    {
        if (this.props.data?.imageURL) {
            await this.fetchImageWithAuth();
        }
    }

    async componentDidUpdate(prevProps: PersonViewProps): Promise<void>
    {
        if (prevProps.data?.imageURL !== this.props.data?.imageURL && this.props.data?.imageURL) {
            await this.fetchImageWithAuth();
        }
    }

    async fetchImageWithAuth(): Promise<void>
    {
        try {
            const accessToken = await this.studentController.authService.getAccessToken();
            const imageUrl = `${this.studentController.baseUrl + this.props.data.imageURL}`;

            const response = await fetch(imageUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const dataUrl = URL.createObjectURL(blob);
                this.setState({ imageDataUrl: dataUrl });
            } else {
                console.error('Failed to fetch image:', response.status);
            }
        } catch (error) {
            console.error('Error fetching image with auth:', error);
        }
    }

    componentWillUnmount(): void
    {
        // Clean up the object URL to prevent memory leaks
        if (this.state.imageDataUrl && this.state.imageDataUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.state.imageDataUrl);
        }
    }

    render(): React.ReactNode
    {
        if (this.props.data == null || !Object.keys(this.props.data).length)
            return <div><b> - </b></div>;

        return <div style={{ paddingLeft: 0 + "px" }}>
            {
                this.state.imageDataUrl ?
                    <Image className={"person-image"} src={this.state.imageDataUrl} roundedCircle />
                    :
                    ""
            }
            <b className="align-middle"> {this.props.data.fullName}</b>
            {/*
                (this.props.data.departments && this.props.data.departments.length > 0 && this.props.admins)
                &&
                <OverlayTrigger
                    key={"department"}
                    placement={"top"}
                    overlay={
                        <Tooltip id={"depatment"}>
                            <strong>{this.props.data.departments.join(", ")}</strong>.
                            </Tooltip>
                    }
                >
                    <i style={{ marginTop: "5px" }} className={"float-right fas fa-info-circle"}></i>
                </OverlayTrigger>
            */}
        </div>
    }
}
